<div class="main-panel">
  <div>
    <div class="row m-0 p-2" id="topSec">
      <div class="col-12">
        <alert class="alert-position"></alert>
      </div>
      <h2 class="col-12 p-3 back-btn-header" id="myUserLabel">
        <label class="login-back-btn" (click)="previousState()">
          <img src="../../assets/img/back.png">
        </label>
        <div class="log-out-menu c-pointer">
          <a (click)=logOut()>
            <label class="fa fa-power-off"></label>
          </a>
        </div>
      </h2>
    </div>
    <div class="row m-0 mt-0" id="tran-sce-info" [style.height.px]="midSecHt">
      <div class="col-12 mt-0 txnSec-wrpr h-100">
        <div class="h-100">
          <div class=" txnSec-wrpr-content h-100">
            <h2 class="lts-txn-col">
              <span class="lts-txn-ttl">Latest Transactions</span>
            </h2>
            <div class="txnSec"
            infiniteScroll
            [infiniteScrollDistance]="1"
            [infiniteScrollThrottle]="100"
            (scrolled)="onScroll()"
            [scrollWindow]="false">
            <div class="ind-txn" *ngFor="let item of transactions">
              <div class="txnSec-bdr d-flex" [ngClass]="{'active':item.displayDetail}">
                <div class="txnSec-inner w-95">
                  <div class="txnSec-img" [ngStyle]="{'background-color':gettxnIconColour(item)}">
                    <img [src]="getTxnTypeIcon(item)">
                  </div>
                  <div class="clearfix">
                    <div class="pull-left tran-ttl">{{item.category}}</div>
                    <div class="pull-right tran-ttl" [ngClass]="{'active':item.accountEntryType==='CREDIT'}">
                      <span *ngIf="item.accountEntryType==='DEBIT'">- </span> <span *ngIf="item.accountEntryType==='CREDIT'">+ </span>₹{{item.amount.toLocaleString('en-IN')}}</div>
                  </div>
                  <div class="clearfix">
                    <div class="pull-left tran-dt">{{item.serviceProvider}}</div>
                    <div class="pull-right tran-dt">{{getTxnTimeToDisplay(item.timeElapsed,item.txnDate)}}</div>
                  </div>
                </div>
                <div class="arrow-icon" (click)="getDisplayDetail(item)">
                  <span class="fa fa-angle-down" *ngIf="!item.displayDetail"></span>
                  <span class="fa fa-angle-up" *ngIf="item.displayDetail"></span>
                </div>
              </div>
              <div class="trx-dtls" *ngIf="item.displayDetail">
                <div class="trx-dt">{{moment(item.txnDate).format('DD MMMM YYYY')}}
                  <br>
                  <span>{{moment(item.txnDate).format('h:mm A')}}</span>
                </div>
                <div class="trx-dtl">{{item.narration}}</div>
              </div>
            </div>
            <div class="txnSec-spinner" [ngClass]="{'txnSec-spinner-center':item.showPageLoader}" *ngIf="gettingTxn">
              <div class="txnSec-inner pl-0">
                <span class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </span>
              </div>
            </div>
            <div class="txnSec-bdr" *ngIf="noMoreTxnText">
              <div class="txnSec-inner-notext">
                <span>{{noMoreTxnText}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
